import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';

import {
  $cartState,
  handleSelectProductSize,
} from '../../../store/models/cart';
import CardItem from './CardItem';
import { $productsState } from '../../../store/models/products';

import styles from './styles.module.scss';

const GrassSizeSelectBar = () => {
  const { grasses } = useUnit($productsState);
  const { selectedProductSize } = useUnit($cartState);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const handleOptionChange = (event: any) => {
    let newSize = event.target.value;
    let newPath = location.pathname;

    if (newPath.includes('/products/mini')) {
      newPath = newPath.replace('/products/mini', '/products/standard');
    } else if (newPath.includes('/products/standard')) {
      newPath = newPath.replace('/products/standard', '/products/mini');
    }

    handleSelectProductSize(newSize);
    navigate(newPath);
  };

  return (
    <div className={styles.grassSizeSelectBar}>
      <div className={styles.title}>{t('selectGrassSize')}</div>
      <div className={styles.radioGroup}>
        {grasses?.map((product) => {
          return (
            <label
              className={
                selectedProductSize === product?.size ? 'selected' : ''
              }
              key={product?.size}
            >
              <input
                type="radio"
                value={product?.size}
                checked={selectedProductSize === product?.size}
                onChange={handleOptionChange}
              />
              <CardItem
                seleted={selectedProductSize === product?.size}
                type={product?.size}
                cardData={product}
              />
            </label>
          );
        })}
      </div>
    </div>
  );
};

export default GrassSizeSelectBar;
